@if (button) {
  <button class="btn w-full" [class]="innerClass">
    <span class="loading loading-dots loading-lg"></span>
  </button>
}

@if (bar) {
  <progress class="progress w-full"></progress>
}

@if (!button && !bar) {
  <span class="loading loading-dots loading-lg"></span>
}
